import { Controller } from "@hotwired/stimulus"
import { ToastManager } from "../night_warrior/modules/toast"

export default class extends Controller {
  static targets = [ "payload" ]

  connect() {
    ToastManager.init()
  }

  payloadTargetConnected(element) {
    ToastManager.show({
      type: element.dataset.type || "info",
      title: element.dataset.title || "Notification",
      message: element.dataset.message || "",
      url: element.dataset.url || "",
    })
    element.remove()
  }
}
